/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=fd03197a"
const script = {}

import exportComponent from "E:\\work\\wwwroot\\new-landing-page-h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__